import * as React from "react";
import RadioButton from "./RadioButton";
interface BooleanRadioButtonProps {
    /**
     * The value of the radio button.
     */
    value: boolean;
    // TODO: this can be made required once we isolate usages of radio groups with a single option
    /**
     * The label of the radio button.
     */
    label?: React.ReactNode;
    /**
     * Controls whether the radio button is the default option.
     * The label of a default option will have "(default)" appended to it.
     */
    isDefault?: boolean;
    /**
     * Controls whether the radio button is disabled.
     */
    disabled?: boolean;
    /**
     * The accessible name of the radio button.
     */
    accessibleName?: string;
}
/* @deprecated
 * Deprecated: 18/08/2025
 * Migration guidelines: This component is deprecated and will be removed in a future release.
 * This is part of our ongoing improvements to forms and input components to enhance usability and accessibility.
 *
 * Please migrate to the RadioButtonNew component where possible.
 *
 * We recognize BooleanRadioButton has different styling; if that prevents an immediate swap, you may continue using this
 * component until all the new form components are in place.
 */
export function BooleanRadioButton({ isDefault, label, disabled, value, accessibleName }: BooleanRadioButtonProps) {
    return <RadioButton label={label} value={`${value}`} isDefault={isDefault} disabled={disabled} accessibleName={accessibleName}/>;
}
